{
  "PDF preview": "PDF preview",
  "Zoom out": "Zoom out",
  "Zoom in": "Zoom in",
  "Fit width": "Fit width",
  "Choose valid collection columns without duplicates.": "Choose valid collection columns without duplicates.",
  "Settings": "Settings",
  "Main menu": "Main menu",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", not",
  ". Changing construction class requires a different identity.": ". Changing construction class requires a different identity.",
  ". It is shown only once.": ". It is shown only once.",
  ". Where-used follows the actual structure—not the numbering path.": ". Where-used follows the actual structure—not the numbering path.",
  "? The history remains.": "? The history remains.",
  "? The original part remains in the registry.": "? The original part remains in the registry.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "A PIN needs a project/product version and at least one identity node (maximum depth 32).",
  "A change is awaiting confirmation": "A change is awaiting confirmation",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.",
  "A new link will replace the previous invitation link for": "A new link will replace the previous invitation link for",
  "A part cannot replace itself.": "A part cannot replace itself.",
  "A piece part cannot have a configuration.": "A piece part cannot have a configuration.",
  "A piece part cannot have controlled children.": "A piece part cannot have controlled children.",
  "A piece part cannot retain controlled children.": "A piece part cannot retain controlled children.",
  "A qualified reference must select a released revision.": "A qualified reference must select a released revision.",
  "A verified Google email is required.": "A verified Google email is required.",
  "ALPHA": "ALPHA",
  "About {value0}": "About {value0}",
  "Accept company invitation": "Accept company invitation",
  "Account": "Account",
  "Account and company settings": "Account and company settings",
  "Active": "Active",
  "Active assembly": "Active assembly",
  "Add alias": "Add alias",
  "Add code": "Add code",
  "Add directional replacement": "Add directional replacement",
  "Add part": "Add part",
  "Add replacement": "Add replacement",
  "Add to {value0}": "Add to {value0}",
  "Adding…": "Adding…",
  "Alias notes": "Alias notes",
  "Alias organization": "Alias organization",
  "Alias type": "Alias type",
  "All alias types": "All alias types",
  "All companies": "All companies",
  "All selected child revisions must be released.": "All selected child revisions must be released.",
  "All states": "All states",
  "All types": "All types",
  "Aluminium": "Aluminium",
  "An assembly needs at least one controlled child before release.": "An assembly needs at least one controlled child before release.",
  "An example drawing change tightens a tolerance.": "An example drawing change tightens a tolerance.",
  "An external alias cannot impersonate another canonical part number.": "An external alias cannot impersonate another canonical part number.",
  "An identifier or historical alias already occupies the requested number.": "An identifier or historical alias already occupies the requested number.",
  "An independently orderable configured product needs its own assembly P/N.": "An independently orderable configured product needs its own assembly P/N.",
  "An invitation is already pending. Replace its link instead.": "An invitation is already pending. Replace its link instead.",
  "An occurrence cannot be moved to another owner by editing it.": "An occurrence cannot be moved to another owner by editing it.",
  "Another change was being saved. Retry this same request.": "Another change was being saved. Retry this same request.",
  "Another owner must accept membership before removing the last owner.": "Another owner must accept membership before removing the last owner.",
  "Another project": "Another project",
  "Apply filters": "Apply filters",
  "Arm": "Arm",
  "Arm assembly": "Arm assembly",
  "As authored": "As authored",
  "Ask a company owner to register a new code.": "Ask a company owner to register a new code.",
  "Assembly": "Assembly",
  "Assembly configurations": "Assembly configurations",
  "Assignment correction": "Assignment correction",
  "Back to blueprint": "Back to blueprint",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.",
  "Best match": "Best match",
  "Bonded": "Bonded",
  "Bonded assembly": "Bonded assembly",
  "Bonded grip": "Bonded grip",
  "Both leaders point to the same P/N.": "Both leaders point to the same P/N.",
  "CF": "CF",
  "Cancel": "Cancel",
  "Cancel {value0} edit": "Cancel {value0} edit",
  "Carbon fibre": "Carbon fibre",
  "Change {value0}'s role": "Change {value0}'s role",
  "Check result": "Check result",
  "Choose Active, Obsolete or Retired.": "Choose Active, Obsolete or Retired.",
  "Choose Owner, Editor or Viewer.": "Choose Owner, Editor or Viewer.",
  "Choose P, A, W, G or R.": "Choose P, A, W, G or R.",
  "Choose a company": "Choose a company",
  "Choose a measurement unit preference.": "Choose a measurement unit preference.",
  "Choose a part and exact revision from this company.": "Choose a part and exact revision from this company.",
  "Choose a product version from the default project.": "Choose a product version from the default project.",
  "Choose a standard position or register its code in this company.": "Choose a standard position or register its code in this company.",
  "Choose a supplier, manufacturer or customer alias.": "Choose a supplier, manufacturer or customer alias.",
  "Choose a supported interface language.": "Choose a supported interface language.",
  "Choose a supported regional format.": "Choose a supported regional format.",
  "Choose a table density.": "Choose a table density.",
  "Choose a valid alias type.": "Choose a valid alias type.",
  "Choose a valid part state.": "Choose a valid part state.",
  "Choose a valid part type.": "Choose a valid part type.",
  "Choose a valid results page and page size.": "Choose a valid results page and page size.",
  "Choose a valid search order.": "Choose a valid search order.",
  "Choose a valid time zone.": "Choose a valid time zone.",
  "Choose an assembly parent in the selected product version.": "Choose an assembly parent in the selected product version.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Choose an assembly parent outside this identity's descendant graph, in the selected product version.",
  "Choose an editable assembly and an exact part revision.": "Choose an editable assembly and an exact part revision.",
  "Choose each time": "Choose each time",
  "Choose exactly one structure owner.": "Choose exactly one structure owner.",
  "Choose its revision and quantity to add it to this assembly.": "Choose its revision and quantity to add it to this assembly.",
  "Choose one structure owner.": "Choose one structure owner.",
  "Choose the default company first.": "Choose the default company first.",
  "Choose the part that can replace this one.": "Choose the part that can replace this one.",
  "Class": "Class",
  "Clear filters": "Clear filters",
  "Close": "Close",
  "Close reuse parts": "Close reuse parts",
  "Close {value0}": "Close {value0}",
  "Code": "Code",
  "Comfortable": "Comfortable",
  "Compact": "Compact",
  "Companies": "Companies",
  "Company": "Company",
  "Company code": "Company code",
  "Company name": "Company name",
  "Company not found.": "Company not found.",
  "Company parts": "Company parts",
  "Company settings": "Company settings",
  "Company-wide role": "Company-wide role",
  "Configuration": "Configuration",
  "Configuration name": "Configuration name",
  "Configurations": "Configurations",
  "Configurations apply to assemblies, not piece parts.": "Configurations apply to assemblies, not piece parts.",
  "Construction classes": "Construction classes",
  "Copy a revision of this part.": "Copy a revision of this part.",
  "Correct engineering identity": "Correct engineering identity",
  "Corrected text": "Corrected text",
  "Correction & replacement": "Correction & replacement",
  "Correction reason": "Correction reason",
  "Cover": "Cover",
  "Cover numbered beneath it": "Cover numbered beneath it",
  "Cover revisions": "Cover revisions",
  "Cover · 1 each · forearm": "Cover · 1 each · forearm",
  "Create company": "Create company",
  "Create configuration": "Create configuration",
  "Create invitation": "Create invitation",
  "Create project": "Create project",
  "Create variant": "Create variant",
  "Create version": "Create version",
  "Current structure": "Current structure",
  "Default quantity unit": "Default quantity unit",
  "Default workspace": "Default workspace",
  "Description": "Description",
  "Details": "Details",
  "Different identity": "Different identity",
  "Directional replacements": "Directional replacements",
  "Draft": "Draft",
  "Drawing unavailable. Part-number examples remain interactive.": "Drawing unavailable. Part-number examples remain interactive.",
  "ER": "ER",
  "Edit company": "Edit company",
  "Edit configuration": "Edit configuration",
  "Edit details": "Edit details",
  "Edit part details": "Edit part details",
  "Edit part use": "Edit part use",
  "Edit product version": "Edit product version",
  "Edit project": "Edit project",
  "Editor": "Editor",
  "Engineering": "Engineering",
  "Engineering Registry": "Engineering Registry",
  "Enter a canonical PIN.": "Enter a canonical PIN.",
  "Enter a position code.": "Enter a position code.",
  "Enter a positive quantity and a unit.": "Enter a positive quantity and a unit.",
  "Enter a valid email address.": "Enter a valid email address.",
  "Enter a variant code.": "Enter a variant code.",
  "Exact child revision": "Exact child revision",
  "Exact children in this baseline": "Exact children in this baseline",
  "Existing codes…": "Existing codes…",
  "Existing hand, used in V": "Existing hand, used in V",
  "Existing part": "Existing part",
  "Explain": "Explain",
  "External aliases": "External aliases",
  "External part number": "External part number",
  "Filters": "Filters",
  "Find an existing part": "Find an existing part",
  "Find parts": "Find parts",
  "Find {value0}": "Find {value0}",
  "For an unrelated part, leave Related part empty to allocate a new number.": "For an unrelated part, leave Related part empty to allocate a new number.",
  "Forearm cover": "Forearm cover",
  "Front view · left/right is the robot’s own left/right": "Front view · left/right is the robot’s own left/right",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.",
  "Google account email": "Google account email",
  "Google could not verify this sign-in. Try again.": "Google could not verify this sign-in. Try again.",
  "Google sign-in could not load. Check your connection and try again.": "Google sign-in could not load. Check your connection and try again.",
  "Google sign-in is not configured.": "Google sign-in is not configured.",
  "Hand identities": "Hand identities",
  "Head casing": "Head casing",
  "Hide": "Hide",
  "Historical rename": "Historical rename",
  "History": "History",
  "Hole Ø6 mm · tolerance ±": "Hole Ø6 mm · tolerance ±",
  "Identity family": "Identity family",
  "Identity history examples": "Identity history examples",
  "Illustrative example · not your registry": "Illustrative example · not your registry",
  "Imperial": "Imperial",
  "Interactive robot part numbers": "Interactive robot part numbers",
  "Invitation link": "Invitation link",
  "Invitation not found.": "Invitation not found.",
  "Invite person": "Invite person",
  "Issue part number": "Issue part number",
  "Issue variant": "Issue variant",
  "Issuing the cover beneath it appends": "Issuing the cover beneath it appends",
  "It does not tell you where it is used now.": "It does not tell you where it is used now.",
  "Keep the part number and name columns; each column may appear only once.": "Keep the part number and name columns; each column may appear only once.",
  "Knee pin ×2": "Knee pin ×2",
  "Language": "Language",
  "Left / right": "Left / right",
  "Left hand": "Left hand",
  "Left hand · 1 each · wrist": "Left hand · 1 each · wrist",
  "Loading…": "Loading…",
  "Main navigation": "Main navigation",
  "Material": "Material",
  "Meaning": "Meaning",
  "Measurement units": "Measurement units",
  "Members": "Members",
  "Metric": "Metric",
  "Move {column} down": "Move {column} down",
  "Move {column} up": "Move {column} up",
  "Name": "Name",
  "Navigation": "Navigation",
  "Neither family membership nor a variant code promises interchangeability.": "Neither family membership nor a variant code promises interchangeability.",
  "New assembly": "New assembly",
  "New camera in V2": "New camera in V2",
  "New camera, first numbered in V2": "New camera, first numbered in V2",
  "New codes are registered by a company owner.": "New codes are registered by a company owner.",
  "New company": "New company",
  "New configuration": "New configuration",
  "New part": "New part",
  "New product version": "New product version",
  "New project": "New project",
  "New revision": "New revision",
  "New version": "New version",
  "No choices available.": "No choices available.",
  "No parts yet.": "No parts yet.",
  "No selected occurrences.": "No selected occurrences.",
  "None": "None",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Not confirmed yet. Retry the saved change to resolve it safely.",
  "Not found.": "Not found.",
  "Notes": "Notes",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.",
  "Numbering concept": "Numbering concept",
  "Numbering path": "Numbering path",
  "Obsolete": "Obsolete",
  "Old text": "Old text",
  "Only !REV changes.": "Only !REV changes.",
  "Only company owners can manage membership.": "Only company owners can manage membership.",
  "Only the configured administrator can create companies.": "Only the configured administrator can create companies.",
  "Open PIN": "Open PIN",
  "Open navigation": "Open navigation",
  "Open project explorer": "Open project explorer",
  "Organization": "Organization",
  "Original identity": "Original identity",
  "Overview": "Overview",
  "Owner": "Owner",
  "P/N prefix": "P/N prefix",
  "P/N preview": "P/N preview",
  "Page not found": "Page not found",
  "Part": "Part",
  "Part name": "Part name",
  "Part number": "Part number",
  "Part number preview": "Part number preview",
  "Part number ↑": "Part number ↑",
  "Part number ↓": "Part number ↓",
  "Part number, name, material or alias": "Part number, name, material or alias",
  "Part numbering guide": "Part numbering guide",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Part prefixes change together; controlled historical identifiers keep redirects.",
  "Part record": "Part record",
  "Part section": "Part section",
  "Part type": "Part type",
  "Parts": "Parts",
  "Parts first numbered in this product version.": "Parts first numbered in this product version.",
  "Per page": "Per page",
  "Personal preferences": "Personal preferences",
  "Piece": "Piece",
  "Piece part": "Piece part",
  "Piece parts cannot have controlled children.": "Piece parts cannot have controlled children.",
  "Piece parts do not have assembly configurations.": "Piece parts do not have assembly configurations.",
  "Position": "Position",
  "Position code": "Position code",
  "Position codes contain 1–12 uppercase letters.": "Position codes contain 1–12 uppercase letters.",
  "Product shown": "Product shown",
  "Product version": "Product version",
  "Product versions": "Product versions",
  "Project": "Project",
  "Project / product version": "Project / product version",
  "Project code": "Project code",
  "Project explorer": "Project explorer",
  "Project name": "Project name",
  "Project settings": "Project settings",
  "Project workspace": "Project workspace",
  "Projects": "Projects",
  "Quantity": "Quantity",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "Quantity must be positive, at most one billion, with no more than six decimal places.",
  "ROBOT project": "ROBOT project",
  "Reason for changing the code": "Reason for changing the code",
  "Reason for correcting the code": "Reason for correcting the code",
  "Reason for correcting version number": "Reason for correcting version number",
  "Regional format": "Regional format",
  "Register code": "Register code",
  "Register variant code": "Register variant code",
  "Registered meanings cannot be reassigned after use.": "Registered meanings cannot be reassigned after use.",
  "Registered {value0} codes": "Registered {value0} codes",
  "Registry": "Registry",
  "Related identities are not automatically interchangeable.": "Related identities are not automatically interchangeable.",
  "Related part": "Related part",
  "Release configuration": "Release configuration",
  "Release each selected child revision before releasing this assembly.": "Release each selected child revision before releasing this assembly.",
  "Release the assembly revision before releasing this configuration.": "Release the assembly revision before releasing this configuration.",
  "Released": "Released",
  "Released arm baseline": "Released arm baseline",
  "Released configurations cannot be changed. Create a new configuration.": "Released configurations cannot be changed. Create a new configuration.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Released definitions stay unchanged. Create a new revision to make changes.",
  "Released structures stay unchanged. Create a new revision.": "Released structures stay unchanged. Create a new revision.",
  "Reload saved preferences": "Reload saved preferences",
  "Reload structure": "Reload structure",
  "Remove": "Remove",
  "Remove access": "Remove access",
  "Remove alias": "Remove alias",
  "Remove external alias?": "Remove external alias?",
  "Remove from assembly": "Remove from assembly",
  "Remove from assembly?": "Remove from assembly?",
  "Remove saved search": "Remove saved search",
  "Remove saved search?": "Remove saved search?",
  "Remove {value0}'s access?": "Remove {value0}'s access?",
  "Replace invitation link?": "Replace invitation link?",
  "Replace link": "Replace link",
  "Replacement": "Replacement",
  "Replacement conditions": "Replacement conditions",
  "Results per page": "Results per page",
  "Retired": "Retired",
  "Retry saved change": "Retry saved change",
  "Reuse & structure": "Reuse & structure",
  "Reuse parts": "Reuse parts",
  "Reuse source": "Reuse source",
  "Rev": "Rev",
  "Revision": "Revision",
  "Revision and configuration numbers must be positive.": "Revision and configuration numbers must be positive.",
  "Revision structures are selected by revision, not by project snapshot.": "Revision structures are selected by revision, not by project snapshot.",
  "Revisions": "Revisions",
  "Revoke invitation": "Revoke invitation",
  "Revoke invitation?": "Revoke invitation?",
  "Right hand": "Right hand",
  "Riveted": "Riveted",
  "Riveted assembly": "Riveted assembly",
  "Riveted chest panel": "Riveted chest panel",
  "Robot numbering guide": "Robot numbering guide",
  "Same assembly and revision, different frozen selections.": "Same assembly and revision, different frozen selections.",
  "Same cover identity": "Same cover identity",
  "Save": "Save",
  "Save as a new search": "Save as a new search",
  "Save changes": "Save changes",
  "Save configuration": "Save configuration",
  "Save project": "Save project",
  "Save replacement": "Save replacement",
  "Save search": "Save search",
  "Saved change recovery": "Saved change recovery",
  "Saved searches": "Saved searches",
  "Saving…": "Saving…",
  "Search": "Search",
  "Search columns and order": "Search columns and order",
  "Search company parts": "Search company parts",
  "Search filters": "Search filters",
  "Search name": "Search name",
  "Search order": "Search order",
  "Search part numbers or names": "Search part numbers or names",
  "Searching…": "Searching…",
  "Search…": "Search…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.",
  "Select a revision of this assembly.": "Select a revision of this assembly.",
  "Select a variant code registered in this company.": "Select a variant code registered in this company.",
  "Select an assembly revision.": "Select an assembly revision.",
  "Select an exact child revision.": "Select an exact child revision.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Select at least one child occurrence before releasing an assembly configuration.",
  "Selected engineering definition": "Selected engineering definition",
  "Selected revision": "Selected revision",
  "Send this link to": "Send this link to",
  "Separable": "Separable",
  "Separable assembly": "Separable assembly",
  "Several parts use this external alias. Search it and choose the correct part.": "Several parts use this external alias. Search it and choose the correct part.",
  "Show V": "Show V",
  "Show all company parts": "Show all company parts",
  "Show {column}": "Show {column}",
  "Showing the first": "Showing the first",
  "Shown in product version V": "Shown in product version V",
  "Sign in first.": "Sign in first.",
  "Sign in to continue.": "Sign in to continue.",
  "Sign in to your engineering workspace.": "Sign in to your engineering workspace.",
  "Sign in with the Google account named on this invitation.": "Sign in with the Google account named on this invitation.",
  "Sign out": "Sign out",
  "Signing in…": "Signing in…",
  "Skip to content": "Skip to content",
  "Sort": "Sort",
  "Standard position meanings cannot be changed.": "Standard position meanings cannot be changed.",
  "State": "State",
  "Structure": "Structure",
  "Structure snapshot": "Structure snapshot",
  "Structure snapshot not found.": "Structure snapshot not found.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.",
  "Switch to {value0} appearance": "Switch to {value0} appearance",
  "Table density": "Table density",
  "That record was not found in this company.": "That record was not found in this company.",
  "The corrected identifier must differ from the current identifier.": "The corrected identifier must differ from the current identifier.",
  "The correction creates duplicate identifiers.": "The correction creates duplicate identifiers.",
  "The identifier number is outside the supported positive integer range.": "The identifier number is outside the supported positive integer range.",
  "The next number changed. Review the updated preview, then issue again.": "The next number changed. Review the updated preview, then issue again.",
  "The number is allocated within its prefix:": "The number is allocated within its prefix:",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.",
  "The part is saved in the company registry.": "The part is saved in the company registry.",
  "The pending invitation for": "The pending invitation for",
  "The prefix is ROBOT-V1.2A.": "The prefix is ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "The related family must have the same product version and origin parent.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "The request could not be completed. Retry or reload; confirm any pending change before editing again.",
  "The request could not be read. Check your input and try again.": "The request could not be read. Check your input and try again.",
  "The revision and configuration select different assembly baselines.": "The revision and configuration select different assembly baselines.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right",
  "The selected part may replace": "The selected part may replace",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.",
  "This PIN was not found in the selected company.": "This PIN was not found in the selected company.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "This baseline uses multiple revisions of the child. Specify !REV explicitly.",
  "This change conflicts with an existing record. Reload and review your changes.": "This change conflicts with an existing record. Reload and review your changes.",
  "This child revision is not in the selected parent baseline.": "This child revision is not in the selected parent baseline.",
  "This code was registered elsewhere. Review its meaning before using it.": "This code was registered elsewhere. Review its meaning before using it.",
  "This configuration is already released.": "This configuration is already released.",
  "This destination is read-only or the revision is unavailable.": "This destination is read-only or the revision is unavailable.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "This family number belongs to another family. Issue a related identity explicitly instead.",
  "This identifier is reserved by a historical rename.": "This identifier is reserved by a historical rename.",
  "This invitation has expired or been revoked.": "This invitation has expired or been revoked.",
  "This invitation has expired, was replaced, or is no longer pending.": "This invitation has expired, was replaced, or is no longer pending.",
  "This invitation is no longer pending.": "This invitation is no longer pending.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.",
  "This occurrence would create a structure cycle.": "This occurrence would create a structure cycle.",
  "This part number already exists. Choose a different variant or position.": "This part number already exists. Choose a different variant or position.",
  "This person is already a member. Change their role in Members.": "This person is already a member. Change their role in Members.",
  "This product version number is already assigned.": "This product version number is already assigned.",
  "This project code already exists.": "This project code already exists.",
  "This record changed. Reload it before saving again.": "This record changed. Reload it before saving again.",
  "This released configuration does not exist.": "This released configuration does not exist.",
  "This replacement direction already exists.": "This replacement direction already exists.",
  "This revision does not exist.": "This revision does not exist.",
  "This revision is already released.": "This revision is already released.",
  "This saved search belongs to another person.": "This saved search belongs to another person.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "This updates the project's part-number prefixes. Controlled identities retain historical redirects.",
  "Time zone": "Time zone",
  "Try again": "Try again",
  "Two hands, two identities.": "Two hands, two identities.",
  "Two occurrences, one part": "Two occurrences, one part",
  "Unit": "Unit",
  "Unsaved search": "Unsaved search",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Use PROJECT-V1 followed by unpadded identity nodes.",
  "Use a positive product version number.": "Use a positive product version number.",
  "Use a positive, unpadded family number.": "Use a positive, unpadded family number.",
  "Use a whole number for the search filter.": "Use a whole number for the search filter.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).",
  "Use code": "Use code",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.",
  "Using this pin in V2 or another project in the same company keeps": "Using this pin in V2 or another project in the same company keeps",
  "V1 tells you where a part was first numbered.": "V1 tells you where a part was first numbered.",
  "Variant code": "Variant code",
  "Variant codes": "Variant codes",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Variant codes contain uppercase letters and cannot start with REV or CFG.",
  "Variants & replacements": "Variants & replacements",
  "Version name": "Version name",
  "Version name (optional)": "Version name (optional)",
  "Version number": "Version number",
  "View parts": "View parts",
  "Viewer": "Viewer",
  "Wait for a valid part-number preview.": "Wait for a valid part-number preview.",
  "Welded": "Welded",
  "Welded assembly": "Welded assembly",
  "Welded torso frame": "Welded torso frame",
  "Where used": "Where used",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.",
  "Withdraw permission for": "Withdraw permission for",
  "Withdraw replacement": "Withdraw replacement",
  "Withdraw replacement?": "Withdraw replacement?",
  "You are already a member of this company.": "You are already a member of this company.",
  "Your form session expired. Refresh your session, then retry the saved change.": "Your form session expired. Refresh your session, then retry the saved change.",
  "Your preferences changed. Reload before saving again.": "Your preferences changed. Reload before saving again.",
  "across this company": "across this company",
  "and": "and",
  "at {value0}": "at {value0}",
  "dark": "dark",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.",
  "from": "from",
  "from this structure? The original part remains in the company registry.": "from this structure? The original part remains in the company registry.",
  "in this example.": "in this example.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.",
  "issued.": "issued.",
  "light": "light",
  "match": "match",
  "matches": "matches",
  "mm": "mm",
  "of": "of",
  "only under the stated conditions.": "only under the stated conditions.",
  "parts. Search the company to find additional matches.": "parts. Search the company to find additional matches.",
  "to replace": "to replace",
  "will lose access to every project and part in this company.": "will lose access to every project and part in this company.",
  "will no longer work.": "will no longer work.",
  "{field} must contain {minimum}–{maximum} characters.": "{field} must contain {minimum}–{maximum} characters.",
  "{value0} added to {value1}.": "{value0} added to {value1}.",
  "{value0} code": "{value0} code",
  "{value0} cover example": "{value0} cover example",
  "{value0} editor": "{value0} editor",
  "{value0} meaning": "{value0} meaning",
  "{value0} · Rev {value1}": "{value0} · Rev {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· 1 each",
  "· Refine your search for other matches.": "· Refine your search for other matches.",
  "· Revision {value0}": "· Revision {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF changes the identity, not its revision.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "? Its definition and exact child occurrences become immutable. Further changes require a new revision.",
  "Accept invitation": "Accept invitation",
  "Accepting…": "Accepting…",
  "Actions": "Actions",
  "Actions for {value0}": "Actions for {value0}",
  "Add description": "Add description",
  "Add external alias": "Add external alias",
  "An origin parent is selected.": "An origin parent is selected.",
  "Applicability / effectivity": "Applicability / effectivity",
  "Apply identity correction": "Apply identity correction",
  "Assembly revision": "Assembly revision",
  "Both covers share": "Both covers share",
  "Change role": "Change role",
  "Checking number…": "Checking number…",
  "Child REV": "Child REV",
  "Choose a project": "Choose a project",
  "Choose a revision to inspect its exact definition.": "Choose a revision to inspect its exact definition.",
  "Choose a revision to view its exact structure.": "Choose a revision to view its exact structure.",
  "Choose an assembly in the selected product version.": "Choose an assembly in the selected product version.",
  "Choose an exact assembly revision.": "Choose an exact assembly revision.",
  "Choose another company": "Choose another company",
  "Collapse": "Collapse",
  "Company access unavailable": "Company access unavailable",
  "Copied.": "Copied.",
  "Copy link": "Copy link",
  "Copy was unavailable. Select the link and copy it manually.": "Copy was unavailable. Select the link and copy it manually.",
  "Correct identity": "Correct identity",
  "Custom position…": "Custom position…",
  "Definition": "Definition",
  "Details for {value0}": "Details for {value0}",
  "Edit": "Edit",
  "Edit alias {value}": "Edit alias {value}",
  "Edit definition": "Edit definition",
  "Edit external alias": "Edit external alias",
  "Empty definition": "Empty definition",
  "Expand": "Expand",
  "Family number": "Family number",
  "Freeze CFG": "Freeze CFG",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.",
  "Identity": "Identity",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.",
  "Include selected revision": "Include selected revision",
  "Invitations": "Invitations",
  "Join": "Join",
  "Left": "Left",
  "Next": "Next",
  "No child parts.": "No child parts.",
  "No companies yet.": "No companies yet.",
  "No configurations yet.": "No configurations yet.",
  "No external aliases.": "No external aliases.",
  "No invitations.": "No invitations.",
  "No matching choices.": "No matching choices.",
  "No matching parts.": "No matching parts.",
  "No parts in this structure yet.": "No parts in this structure yet.",
  "No product versions in this project.": "No product versions in this project.",
  "No product versions yet.": "No product versions yet.",
  "No projects yet.": "No projects yet.",
  "No replacement relationships.": "No replacement relationships.",
  "No variant code": "No variant code",
  "No variant codes registered.": "No variant codes registered.",
  "Not reserved": "Not reserved",
  "Numbered directly under the product version.": "Numbered directly under the product version.",
  "Open assembly {value0}": "Open assembly {value0}",
  "Open resolved configuration": "Open resolved configuration",
  "Origin product version": "Origin product version",
  "Other positions": "Other positions",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.",
  "Other positions…": "Other positions…",
  "Page {page} of {pages}": "Page {page} of {pages}",
  "Part / P/N": "Part / P/N",
  "Part section not found.": "Part section not found.",
  "Parts in {value0}": "Parts in {value0}",
  "Person": "Person",
  "Piece parts have no child structure.": "Piece parts have no child structure.",
  "Position for occurrence {value0}": "Position for occurrence {value0}",
  "Previous": "Previous",
  "Product root": "Product root",
  "Product structure": "Product structure",
  "Qty": "Qty",
  "Quantity for occurrence {value0}": "Quantity for occurrence {value0}",
  "Quantity for {value0} {value1}": "Quantity for {value0} {value1}",
  "Quantity saved for {value0}.": "Quantity saved for {value0}.",
  "Read-only access": "Read-only access",
  "Reason for correction": "Reason for correction",
  "Registered variant": "Registered variant",
  "Release": "Release",
  "Release revision": "Release revision",
  "Remove alias {value}": "Remove alias {value}",
  "Remove from assembly {value0} {value1}": "Remove from assembly {value0} {value1}",
  "Remove selected occurrence": "Remove selected occurrence",
  "Remove {value0}'s access": "Remove {value0}'s access",
  "Replace invitation link for {value0}": "Replace invitation link for {value0}",
  "Reset quantity for {value0}": "Reset quantity for {value0}",
  "Resolved definition: REV": "Resolved definition: REV",
  "Results: {count}": "Results: {count}",
  "Retry preview": "Retry preview",
  "Revoke": "Revoke",
  "Revoke invitation for {value0}": "Revoke invitation for {value0}",
  "Right": "Right",
  "Role": "Role",
  "Same family number, different identities.": "Same family number, different identities.",
  "Save quantity for {value0}": "Save quantity for {value0}",
  "Search pages": "Search pages",
  "Source product version": "Source product version",
  "Source project": "Source project",
  "Start from": "Start from",
  "Structural class": "Structural class",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "This invitation link is incomplete. Ask the company owner for a replacement link.",
  "This part is not used in a structure or configuration.": "This part is not used in a structure or configuration.",
  "This structure is read-only. Choose a draft revision to edit.": "This structure is read-only. Choose a draft revision to edit.",
  "Unit & position": "Unit & position",
  "Unit for occurrence {value0}": "Unit for occurrence {value0}",
  "Unspecified": "Unspecified",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.",
  "Use product-version root": "Use product-version root",
  "Variant": "Variant",
  "Versions": "Versions",
  "You do not have company access yet. Open an invitation from a company owner.": "You do not have company access yet. Open an invitation from a company owner.",
  "Your account does not have access to this company.": "Your account does not have access to this company.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "and its selected exact child revisions? The assembly and every child revision must already be released.",
  "as": "as",
  "because the new cover was explicitly numbered as related to the existing one.": "because the new cover was explicitly numbered as related to the existing one.",
  "may replace": "may replace",
  "using": "using",
  "· Expires": "· Expires",
  "Sign in again": "Sign in again",
  "Refresh session": "Refresh session",
  "Connection interrupted. Check the saved change before making another edit.": "Connection interrupted. Check the saved change before making another edit.",
  "The request could not be completed.": "The request could not be completed.",
  "Resolve the saved change shown above before making another edit.": "Resolve the saved change shown above before making another edit.",
  "Browser storage is unavailable. Enable it before saving a change.": "Browser storage is unavailable. Enable it before saving a change.",
  "No position": "No position",
  "Not specified.": "Not specified.",
  "No description.": "No description.",
  "Field": "Field",
  "Choose…": "Choose…",
  "Choose": "Choose",
  "Complete {field}.": "Complete {field}.",
  "Check the value of {field}.": "Check the value of {field}.",
  "Do not submit another edit until this change is confirmed.": "Do not submit another edit until this change is confirmed.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.",
  "No variant": "No variant",
  "Company created": "Company created",
  "Company updated": "Company updated",
  "Variant code registered": "Variant code registered",
  "Position code registered": "Position code registered",
  "Role changed": "Role changed",
  "Membership removed": "Membership removed",
  "Invitation created": "Invitation created",
  "Invitation link replaced": "Invitation link replaced",
  "Invitation revoked": "Invitation revoked",
  "Invitation accepted": "Invitation accepted",
  "Revision created": "Revision created",
  "Revision definition updated": "Revision definition updated",
  "Revision released": "Revision released",
  "Structure occurrence added": "Structure occurrence added",
  "Structure occurrence updated": "Structure occurrence updated",
  "Structure occurrence removed": "Structure occurrence removed",
  "Configuration created": "Configuration created",
  "Configuration updated": "Configuration updated",
  "Configuration released": "Configuration released",
  "Replacement recorded": "Replacement recorded",
  "Replacement withdrawn": "Replacement withdrawn",
  "Project created": "Project created",
  "Project updated": "Project updated",
  "Product version created": "Product version created",
  "Product version updated": "Product version updated",
  "Part issued": "Part issued",
  "Part details updated": "Part details updated",
  "alias-added": "External alias added",
  "alias-edited": "External alias edited",
  "alias-removed": "External alias removed",
  "Identity renamed": "Identity renamed",
  "Assignment corrected": "Assignment corrected",
  "North": "North",
  "South": "South",
  "West": "West",
  "East": "East",
  "Front": "Front",
  "Rear": "Rear",
  "Mid": "Mid",
  "Top": "Top",
  "Bottom": "Bottom",
  "Side": "Side",
  "North / south": "North / south",
  "West / east": "West / east",
  "Front / rear": "Front / rear",
  "Top / bottom": "Top / bottom",
  "Custom": "Custom",
  "Family, not an orderable P/N": "Family, not an orderable P/N",
  "Pending": "Pending",
  "Accepted": "Accepted",
  "Revoked": "Revoked",
  "Expired": "Expired",
  "Edit revision definition": "Edit revision definition",
  "Release revision?": "Release revision?",
  "Release configuration?": "Release configuration?",
  "A complete SHA-256 checksum is required.": "A complete SHA-256 checksum is required.",
  "Add comment": "Add comment",
  "Add file": "Add file",
  "All": "All",
  "Applicability": "Applicability",
  "Applicability must refer to a configuration of the owning part.": "Applicability must refer to a configuration of the owning part.",
  "Applicability must refer to a revision of the owning part.": "Applicability must refer to a revision of the owning part.",
  "Applicability notes": "Applicability notes",
  "Attachment": "Attachment",
  "Cancel upload": "Cancel upload",
  "Cancelled": "Cancelled",
  "Checking file…": "Checking file…",
  "Choose Draft or Issued status.": "Choose Draft or Issued status.",
  "Choose Source, Rendition or Attachment.": "Choose Source, Rendition or Attachment.",
  "Choose a draft document or production job for this file.": "Choose a draft document or production job for this file.",
  "Choose a file of this revision.": "Choose a file of this revision.",
  "Choose a registered document type.": "Choose a registered document type.",
  "Choose a supported document owner.": "Choose a supported document owner.",
  "Choose a valid results page and a positive page size.": "Choose a valid results page and a positive page size.",
  "Choose an issued revision of this document.": "Choose an issued revision of this document.",
  "Choose the viewed revision of this document.": "Choose the viewed revision of this document.",
  "Choose this company as the document owner.": "Choose this company as the document owner.",
  "Clear applicability references": "Clear applicability references",
  "Comment": "Comment",
  "Comment history": "Comment history",
  "Comment removed": "Comment removed",
  "Copy this revision into a shared editable draft?": "Copy this revision into a shared editable draft?",
  "Create document": "Create document",
  "Create shared draft": "Create shared draft",
  "Deleted comments retain their history and cannot be edited.": "Deleted comments retain their history and cannot be edited.",
  "Discussion": "Discussion",
  "Document comment added": "Document comment added",
  "Document comment deleted": "Document comment deleted",
  "Document comment edited": "Document comment edited",
  "Document created": "Document created",
  "Document draft created": "Document draft created",
  "Document draft updated": "Document draft updated",
  "Document file": "Document file",
  "Document file linked": "Document file linked",
  "Document file unlinked": "Document file unlinked",
  "Document files published": "Document files published",
  "Document files unpublished": "Document files unpublished",
  "Document information": "Document information",
  "Document issued": "Document issued",
  "Document number": "Document number",
  "Document reader": "Document reader",
  "Document type": "Document type",
  "Document type registered": "Document type registered",
  "Documents": "Documents",
  "Download {name}": "Download {name}",
  "Edit comment": "Edit comment",
  "Edit draft": "Edit draft",
  "Edit history": "Edit history",
  "Exact engineering applicability": "Exact engineering applicability",
  "Exact revision": "Exact revision",
  "File": "File",
  "File name": "File name",
  "File purpose": "File purpose",
  "File size must be between 1 byte and 20 GiB.": "File size must be between 1 byte and 20 GiB.",
  "File storage is not configured.": "File storage is not configured.",
  "File unavailable": "File unavailable",
  "Files": "Files",
  "Files available to anyone with the public link": "Files available to anyone with the public link",
  "Files can only be added to a draft document.": "Files can only be added to a draft document.",
  "Identifier filter": "Identifier filter",
  "Issue revision": "Issue revision",
  "Issue this exact revision? Its metadata and files will become immutable.": "Issue this exact revision? Its metadata and files will become immutable.",
  "Issued": "Issued",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Issued revisions are immutable. Create a shared draft to make changes.",
  "Link at least one verified file before issuing.": "Link at least one verified file before issuing.",
  "New file": "New file",
  "No comments yet.": "No comments yet.",
  "No files in this revision.": "No files in this revision.",
  "No published files.": "No published files.",
  "No revisions available.": "No revisions available.",
  "Only an unfinished upload can be cancelled.": "Only an unfinished upload can be cancelled.",
  "Only issued files can be published.": "Only issued files can be published.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Only length- and SHA-256-verified immutable files can be linked or issued.",
  "Open public link": "Open public link",
  "Owner kind": "Owner kind",
  "Page {page} · {count} documents": "Page {page} · {count} documents",
  "Part revision": "Part revision",
  "Pause": "Pause",
  "Paused": "Paused",
  "Preview is not available for this file. Download it instead.": "Preview is not available for this file. Download it instead.",
  "Preview unavailable. Download the file to view it.": "Preview unavailable. Download the file to view it.",
  "Public description": "Public description",
  "Public links": "Public links",
  "Public title": "Public title",
  "Publication not found.": "Publication not found.",
  "Publish selected files": "Publish selected files",
  "Published document not found.": "Published document not found.",
  "Published file not found.": "Published file not found.",
  "Register document type": "Register document type",
  "Reload revision": "Reload revision",
  "Remove comment": "Remove comment",
  "Remove file": "Remove file",
  "Remove this comment? Its edit history is retained.": "Remove this comment? Its edit history is retained.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "Remove this file from the draft? Earlier issued revisions keep their files.",
  "Remove {name}": "Remove {name}",
  "Rendition": "Rendition",
  "Resume this upload with the recorder who started it.": "Resume this upload with the recorder who started it.",
  "Resume upload": "Resume upload",
  "Revision unavailable": "Revision unavailable",
  "Revision {number}": "Revision {number}",
  "Revision {number} · {status}": "Revision {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Search documents",
  "Select distinct issued files to publish.": "Select distinct issued files to publish.",
  "Select files from this exact issued revision.": "Select files from this exact issued revision.",
  "Select the same file to resume this upload.": "Select the same file to resume this upload.",
  "Source": "Source",
  "Status": "Status",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "Stop subsequent access through this public link? Already downloaded copies are not removed.",
  "That document revision was not found in this company.": "That document revision was not found in this company.",
  "The configuration must select the exact applicability revision.": "The configuration must select the exact applicability revision.",
  "The document input changed during capture. Retry the same request.": "The document input changed during capture. Retry the same request.",
  "The file upload is not complete.": "The file upload is not complete.",
  "The issued files no longer match their immutable manifest.": "The issued files no longer match their immutable manifest.",
  "The issued manifest failed integrity verification.": "The issued manifest failed integrity verification.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "The uploaded file checksum does not match. Cancel this upload and select the original file again.",
  "The uploaded file is unavailable.": "The uploaded file is unavailable.",
  "The verified file must belong to this document.": "The verified file must belong to this document.",
  "This comment is already deleted.": "This comment is already deleted.",
  "This document already has a shared draft.": "This document already has a shared draft.",
  "This document numbering sequence is exhausted.": "This document numbering sequence is exhausted.",
  "This file is not available.": "This file is not available.",
  "This file is unavailable. Contact the company owner.": "This file is unavailable. Contact the company owner.",
  "This revision changed. Reload it before publishing.": "This revision changed. Reload it before publishing.",
  "This upload cannot be verified.": "This upload cannot be verified.",
  "This upload is no longer writable.": "This upload is no longer writable.",
  "This upload was not found.": "This upload was not found.",
  "Title": "Title",
  "Title filter": "Title filter",
  "Type code": "Type code",
  "Type name": "Type name",
  "Unpublish": "Unpublish",
  "Unpublished": "Unpublished",
  "Upload file": "Upload file",
  "Uploaded": "Uploaded",
  "Uploading…": "Uploading…",
  "Use a file name without a path or control characters.": "Use a file name without a path or control characters.",
  "Use a file name without directory separators.": "Use a file name without directory separators.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Use an uppercase alphanumeric type code starting with a letter.",
  "Verified": "Verified",
  "Verifying file…": "Verifying file…",
  "View draft": "View draft",
  "file-upload-created": "File upload created",
  "file-verified": "File verified",
  "{bytes} bytes": "{bytes} bytes",
  "No matching documents.": "No matching documents.",
  "No documents yet.": "No documents yet.",
  "The revision’s applicability details could not be loaded. Try again.": "The revision’s applicability details could not be loaded. Try again.",
  "Comment authors could not be loaded. Try again.": "Comment authors could not be loaded. Try again.",
  "Comment history authors could not be loaded. Try again.": "Comment history authors could not be loaded. Try again.",
  "Choose a saved search": "Choose a saved search",
  "This saved search belongs to another person or collection.": "This saved search belongs to another person or collection.",
  "Choose a saved parts search.": "Choose a saved parts search.",
  "Supply document search filters.": "Supply document search filters.",
  "Pages": "Pages",
  "{from}–{to} of {total}": "{from}–{to} of {total}",
  "Choose lot": "Choose lot",
  "Choose material": "Choose material",
  "No matches": "No matches",
  "Stock": "Stock",
  "Lots": "Lots",
  "Materials": "Materials",
  "Supplier": "Supplier",
  "Material identifier": "Material identifier",
  "Specification": "Specification",
  "Reload latest versions": "Reload latest versions",
  "Edit material": "Edit material",
  "Create material revision": "Create material revision",
  "Edit material revision": "Edit material revision",
  "Release material revision": "Release material revision",
  "Create lot": "Create lot",
  "Choose an exact material revision.": "Choose an exact material revision.",
  "Lot identifier": "Lot identifier",
  "Balances": "Balances",
  "No stock recorded": "No stock recorded",
  "Genealogy": "Genealogy",
  "No linked lots": "No linked lots",
  "To": "To",
  "Reversed": "Reversed",
  "Movement details": "Movement details",
  "Record history": "Record history",
  "Movements": "Movements",
  "Movement type": "Movement type",
  "No movements recorded": "No movements recorded",
  "Original movement": "Original movement",
  "Replaced movement": "Replaced movement",
  "Reversal": "Reversal",
  "Reverse movement": "Reverse movement",
  "Record replacement": "Record replacement",
  "Movement warnings unavailable": "Movement warnings unavailable",
  "Warnings": "Warnings",
  "Actual quantity": "Actual quantity",
  "Location": "Location",
  "Disposition": "Disposition",
  "Use balance location": "Use balance location",
  "Wait for the latest balances.": "Wait for the latest balances.",
  "Choose a lot for every quantity.": "Choose a lot for every quantity.",
  "Source {number}": "Source {number}",
  "Remove source": "Remove source",
  "Add source": "Add source",
  "Output {number}": "Output {number}",
  "Remove output": "Remove output",
  "Add output": "Add output",
  "Destination location": "Destination location",
  "Source reference": "Source reference",
  "Reason": "Reason",
  "Reload latest balances": "Reload latest balances",
  "Receipt": "Receipt",
  "Accept": "Accept",
  "Quarantine": "Quarantine",
  "Transfer": "Transfer",
  "Consume": "Consume",
  "Scrap": "Scrap",
  "Split": "Split",
  "Merge": "Merge",
  "MaterialLots": "Material lots",
  "Receipts": "Receipts",
  "Create material": "Create material",
  "Search lots": "Search lots",
  "Search materials": "Search materials",
  "Select a lot": "Select a lot",
  "Select a material": "Select a material",
  "Supplier reference": "Supplier reference",
  "Supplier lot reference": "Supplier lot reference",
  "Material created": "Material created",
  "Material renamed": "Material renamed",
  "Material revision created": "Material revision created",
  "Material revision edited": "Material revision edited",
  "Material revision released": "Material revision released",
  "Lot created": "Lot created",
  "Correction": "Correction",
  "Record updated": "Record updated",
  "All movements": "All movements",
  "Quarantined": "Quarantined",
  "Not recorded": "Not recorded",
  "No matching records.": "No matching records.",
  "Page": "Page",
  "Evidence warnings": "Evidence warnings",
  "Production": "Production",
  "Create job": "Create job",
  "Routes": "Routes",
  "Search jobs": "Search jobs",
  "Clear part filter": "Clear part filter",
  "No jobs found.": "No jobs found.",
  "Select a job to review or record actual work.": "Select a job to review or record actual work.",
  "Change": "Change",
  "Select an exact definition revision.": "Select an exact definition revision.",
  "Job identifier": "Job identifier",
  "Route input": "Route input",
  "Document inputs": "Document inputs",
  "Select route": "Select route",
  "Back": "Back",
  "Create route": "Create route",
  "Create route revision": "Create route revision",
  "Choose another route": "Choose another route",
  "Inspection expected": "Inspection expected",
  "Route name": "Route name",
  "Operation": "Operation",
  "Instructions": "Instructions",
  "Move up": "Move up",
  "Move down": "Move down",
  "Remove operation": "Remove operation",
  "Add operation": "Add operation",
  "Serials": "Serials",
  "ProductionOutputs": "Production outputs",
  "Operations": "Operations",
  "Inspections": "Inspections",
  "Declarations": "Declarations",
  "Back to collection": "Back to collection",
  "Recorded at": "Recorded at",
  "Created": "Created",
  "Display columns": "Display columns",
  "Import records": "Import records",
  "Preview records": "Preview records",
  "New preview": "New preview",
  "Apply valid rows": "Apply valid rows",
  "Reload preview": "Reload preview",
  "Row {number}": "Row {number}",
  "Applied": "Applied",
  "Apply row": "Apply row",
  "Source name": "Source name",
  "Record type": "Record type",
  "Download CSV template": "Download CSV template",
  "CSV file": "CSV file",
  "Previous imports": "Previous imports",
  "Manual entry": "Manual entry",
  "Choose a CSV file.": "Choose a CSV file.",
  "The CSV file exceeds the import size limit.": "The CSV file exceeds the import size limit.",
  "Serial number": "Serial number",
  "Output source reference": "Output source reference",
  "Step": "Step",
  "Result": "Result",
  "Actual result": "Actual result",
  "Kind": "Kind",
  "Value": "Value",
  "Exact configuration": "Exact configuration",
  "Exact route revision": "Exact route revision",
  "Material definition": "Material definition",
  "Primary definition": "Primary definition",
  "Route revision": "Route revision",
  "Record output": "Record output",
  "Record operation": "Record operation",
  "Record inspection": "Record inspection",
  "Record consumption or component": "Record consumption or component",
  "Declare output": "Declare output",
  "Capture as-built": "Capture as-built",
  "Unnamed record": "Unnamed record",
  "Serial": "Serial",
  "None available": "None available",
  "The selected job was not found in an editable company.": "The selected job was not found in an editable company.",
  "Offline job": "Offline job",
  "Download selected job": "Download selected job",
  "Offline work": "Offline work",
  "Selected job and files saved for offline use.": "Selected job and files saved for offline use.",
  "Download": "Download",
  "bytes": "bytes",
  "Find material lots": "Find material lots",
  "Find component parts": "Find component parts",
  "Correct recorded work": "Correct recorded work",
  "Save correction": "Save correction",
  "Save offline": "Save offline",
  "Wait for evidence to finish saving.": "Wait for evidence to finish saving.",
  "Choose an output with a recorded version.": "Choose an output with a recorded version.",
  "Reconnect and load current records before saving a correction.": "Reconnect and load current records before saving a correction.",
  "Confirm that this correction uses the current stock version.": "Confirm that this correction uses the current stock version.",
  "The original recording is retained. Review current records before submitting a separate correction.": "The original recording is retained. Review current records before submitting a separate correction.",
  "Loading current records": "Loading current records",
  "Current stock": "Current stock",
  "Completed": "Completed",
  "Failed": "Failed",
  "Skipped": "Skipped",
  "InProgress": "In progress",
  "Passed": "Passed",
  "Inconclusive": "Inconclusive",
  "I reviewed the stock conflict and authorize this correction against current stock.": "I reviewed the stock conflict and authorize this correction against current stock.",
  "Quality": "Quality",
  "NotStarted": "Not started",
  "Rejected": "Rejected",
  "As-built": "As-built",
  "Evidence file": "Evidence file",
  "Saving evidence locally": "Saving evidence locally",
  "The correction retains the original evidence attachments.": "The correction retains the original evidence attachments.",
  "Reconnect to verify recorder access before continuing.": "Reconnect to verify recorder access before continuing.",
  "Reconnect as the original offline recorder.": "Reconnect as the original offline recorder.",
  "Offline recording access was revoked. Recorded work is retained.": "Offline recording access was revoked. Recorded work is retained.",
  "Reconnect": "Reconnect",
  "Loading": "Loading",
  "No offline job is open. Download a selected production job while connected.": "No offline job is open. Download a selected production job while connected.",
  "Selected job": "Selected job",
  "Online": "Online",
  "Offline": "Offline",
  "Resume download": "Resume download",
  "Synchronize": "Synchronize",
  "Close offline session": "Close offline session",
  "Captured operations": "Captured operations",
  "No route captured": "No route captured",
  "Recorded inspections": "Recorded inspections",
  "Outputs": "Outputs",
  "No outputs recorded": "No outputs recorded",
  "Downloaded files": "Downloaded files",
  "Material lots": "Material lots",
  "Record work": "Record work",
  "Recorded commands": "Recorded commands",
  "No local commands recorded": "No local commands recorded",
  "Retained original; correction recorded": "Retained original; correction recorded",
  "Retry unchanged": "Retry unchanged",
  "Saved evidence": "Saved evidence",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Close only after all recorded work and evidence are accepted. Local history remains available.",
  "Offline storage is unavailable in this browser.": "Offline storage is unavailable in this browser.",
  "The offline application could not be downloaded. Try again online.": "The offline application could not be downloaded. Try again online.",
  "The offline application is not ready. Reload online and try again.": "The offline application is not ready. Reload online and try again.",
  "An offline update is waiting. Close other registry tabs and reload online.": "An offline update is waiting. Close other registry tabs and reload online.",
  "Verified files": "Verified files",
  "Component part": "Component part",
  "Component serials": "Component serials",
  "Output": "Output",
  "Reserved serial": "Reserved serial",
  "Output lot": "Output lot",
  "Operation order": "Operation order",
  "Shared run": "Shared run",
  "Rework of": "Rework of",
  "Inspection": "Inspection",
  "Actual": "Actual",
  "Operation attempt": "Operation attempt",
  "Material lot": "Material lot",
  "Component serial": "Component serial",
  "Actual revision": "Actual revision",
  "Declaration": "Declaration",
  "Declared state": "Declared state",
  "Amends snapshot": "Amends snapshot",
  "Attach saved evidence": "Attach saved evidence",
  "preparing": "Preparing",
  "downloading": "Downloading",
  "ready": "Ready",
  "rejected": "Rejected",
  "closed": "Closed",
  "pending": "Pending",
  "sending": "Sending",
  "accepted": "Accepted",
  "conflict": "Conflict",
  "staged": "Staged",
  "uploading": "Uploading",
  "verified": "Verified",
  "attached": "Attached",
  "Captured inputs": "Captured inputs",
  "Captured route": "Captured route",
  "Planned components": "Planned components",
  "No planned components.": "No planned components.",
  "No file evidence recorded.": "No file evidence recorded.",
  "Evidence files": "Evidence files",
  "Actual outputs": "Actual outputs",
  "No actual outputs recorded.": "No actual outputs recorded.",
  "Operations and inspections": "Operations and inspections",
  "Create shared run": "Create shared run",
  "Record rework": "Record rework",
  "No operations or inspections recorded.": "No operations or inspections recorded.",
  "Actual components and lots": "Actual components and lots",
  "Record component or lot": "Record component or lot",
  "No actual components recorded.": "No actual components recorded.",
  "Job documents": "Job documents",
  "Whole job": "Whole job",
  "Actual component": "Actual component",
  "Unserialized output": "Unserialized output",
  "Not declared": "Not declared",
  "Declare production": "Declare production",
  "Declare quality": "Declare quality",
  "Amend as-built": "Amend as-built",
  "Declaration history": "Declaration history",
  "As-built history": "As-built history",
  "Snapshot": "Snapshot",
  "Choose a declaration.": "Choose a declaration.",
  "As-built snapshot": "As-built snapshot",
  "Actual output": "Actual output",
  "No serialized units found.": "No serialized units found.",
  "Serialized output": "Serialized output",
  "Clear": "Clear",
  "Choose a result.": "Choose a result.",
  "Inspection name": "Inspection name",
  "Use shared run": "Use shared run",
  "This job is not part of this shared run.": "This job is not part of this shared run.",
  "Choose another run": "Choose another run",
  "Run identifier": "Run identifier",
  "Serialized unit": "Serialized unit",
  "Select the actual component or lot.": "Select the actual component or lot.",
  "Serial units": "Serial units",
  "Allocate serials": "Allocate serials",
  "Import serial labels": "Import serial labels",
  "Void": "Void",
  "Void serial": "Void serial",
  "Reprint label": "Reprint label",
  "Enter positive integer serial numbers.": "Enter positive integer serial numbers.",
  "Number of serials": "Number of serials",
  "Existing serial numbers": "Existing serial numbers",
  "Serial label": "Serial label",
  "Allow pop-ups to print this label.": "Allow pop-ups to print this label.",
  "Print label": "Print label",
  "Lot {lot} uses draft material revision {revision}.": "Lot {lot} uses draft material revision {revision}.",
  "Consumed quarantined stock: {lot}.": "Consumed quarantined stock: {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.",
  "syncing": "Synchronizing",
  "Supply the selected template's values.": "Supply the selected template's values.",
  "Manual intake contains an unknown column.": "Manual intake contains an unknown column.",
  "A manual value is missing or too long.": "A manual value is missing or too long.",
  "Supply CSV text.": "Supply CSV text.",
  "Supply CSV text of at most 1 MiB.": "Supply CSV text of at most 1 MiB.",
  "CSV text cannot contain null characters.": "CSV text cannot contain null characters.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "CSV exceeds the 1 MiB UTF-8 limit.",
  "CSV must contain valid UTF-8 text.": "CSV must contain valid UTF-8 text.",
  "The CSV header is missing.": "The CSV header is missing.",
  "Every header must be unique.": "Every header must be unique.",
  "The template requires this header, even when its values are optional.": "The template requires this header, even when its values are optional.",
  "This column is not in the selected template.": "This column is not in the selected template.",
  "CSV contains more than 500 data rows.": "CSV contains more than 500 data rows.",
  "This row must have exactly the number of fields in the header.": "This row must have exactly the number of fields in the header.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.",
  "A source reference may occur only once in a preview.": "A source reference may occur only once in a preview.",
  "Supply at least one data row.": "Supply at least one data row.",
  "This preview uses an older intake contract. Create a new preview.": "This preview uses an older intake contract. Create a new preview.",
  "The selected row does not match this immutable preview.": "The selected row does not match this immutable preview.",
  "Correct the CSV errors and create a new preview before applying this row.": "Correct the CSV errors and create a new preview before applying this row.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "This source row has already been applied with another payload or recorder. It cannot be overwritten.",
  "This row no longer meets the intake contract. Create a new preview.": "This row no longer meets the intake contract. Create a new preview.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.",
  "No exact company reference matches this value.": "No exact company reference matches this value.",
  "This reference is ambiguous; select an exact source reference.": "This reference is ambiguous; select an exact source reference.",
  "This material identifier already exists; intake does not overwrite definitions.": "This material identifier already exists; intake does not overwrite definitions.",
  "This lot identifier already exists; intake does not overwrite lots.": "This lot identifier already exists; intake does not overwrite lots.",
  "Use the exact material revision unit.": "Use the exact material revision unit.",
  "Use the exact authored lot unit; stock is not converted.": "Use the exact authored lot unit; stock is not converted.",
  "The job must produce the exact selected part.": "The job must produce the exact selected part.",
  "This serial is already allocated or imported and cannot be reused.": "This serial is already allocated or imported and cannot be reused.",
  "A serialized output is exactly one ea.": "A serialized output is exactly one ea.",
  "A part job cannot declare a material lot output.": "A part job cannot declare a material lot output.",
  "The operation must exist in the job's captured route.": "The operation must exist in the job's captured route.",
  "Select one actual output by its exact source reference.": "Select one actual output by its exact source reference.",
  "Use at most {maximum} characters.": "Use at most {maximum} characters.",
  "A value is required.": "A value is required.",
  "Use a positive, unpadded integer.": "Use a positive, unpadded integer.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Choose Accepted or Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Choose Completed, Failed, Skipped or InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Choose Passed, Failed or Inconclusive.",
  "An imported serial requires its complete part PIN.": "An imported serial requires its complete part PIN.",
  "Choose Production or Quality.": "Choose Production or Quality.",
  "Choose a declaration value belonging to this kind.": "Choose a declaration value belonging to this kind.",
  "This intake preview was not found for this recorder and company.": "This intake preview was not found for this recorder and company.",
  "This preview row was not found.": "This preview row was not found.",
  "Choose a published intake template.": "Choose a published intake template.",
  "Use an actual UTC timestamp.": "Use an actual UTC timestamp.",
  "This material identifier already exists.": "This material identifier already exists.",
  "Released or used definitions stay unchanged. Create a new revision.": "Released or used definitions stay unchanged. Create a new revision.",
  "This material revision is already released.": "This material revision is already released.",
  "Use the exact material revision unit; stock is not converted.": "Use the exact material revision unit; stock is not converted.",
  "This lot identifier already exists.": "This lot identifier already exists.",
  "This lot changed. Reload its balances before recording stock.": "This lot changed. Reload its balances before recording stock.",
  "Use the lot's exact authored unit; stock is not converted.": "Use the lot's exact authored unit; stock is not converted.",
  "Reverse the original movement before recording its replacement.": "Reverse the original movement before recording its replacement.",
  "This movement already has a replacement.": "This movement already has a replacement.",
  "This movement has already been corrected.": "This movement has already been corrected.",
  "Use an exact location without surrounding whitespace.": "Use an exact location without surrounding whitespace.",
  "Split and merge require the same exact material revision.": "Split and merge require the same exact material revision.",
  "Split and merge preserve disposition.": "Split and merge preserve disposition.",
  "Split and merge quantities must match exactly.": "Split and merge quantities must match exactly.",
  "This split or merge would create a cycle in the retained lot genealogy.": "This split or merge would create a cycle in the retained lot genealogy.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "Quantity must be positive with at most six decimal places and twelve integer digits.",
  "Offline storage is unavailable. No local save was confirmed.": "Offline storage is unavailable. No local save was confirmed.",
  "Offline recording requires browser storage locking.": "Offline recording requires browser storage locking.",
  "Offline storage could not save the change. Keep the original work and retry.": "Offline storage could not save the change. Keep the original work and retry.",
  "Offline session not found.": "Offline session not found.",
  "Resolve the saved change shown above before synchronizing offline work.": "Resolve the saved change shown above before synchronizing offline work.",
  "This offline session is not the active recorder.": "This offline session is not the active recorder.",
  "Offline file storage is unavailable in this browser.": "Offline file storage is unavailable in this browser.",
  "Offline storage capacity cannot be checked.": "Offline storage capacity cannot be checked.",
  "Not enough browser storage for the selected offline files.": "Not enough browser storage for the selected offline files.",
  "Streaming downloads are unavailable.": "Streaming downloads are unavailable.",
  "Choose one job and distinct offline files.": "Choose one job and distinct offline files.",
  "Choose distinct material lots and component units for offline use.": "Choose distinct material lots and component units for offline use.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.",
  "Finish preparation or closing before resolving offline work.": "Finish preparation or closing before resolving offline work.",
  "Choose an unresolved conflicting or rejected command.": "Choose an unresolved conflicting or rejected command.",
  "This offline session is not ready for new commands.": "This offline session is not ready for new commands.",
  "Choose distinct evidence staged in this offline session.": "Choose distinct evidence staged in this offline session.",
  "Only operation attempts and inspections support staged evidence.": "Only operation attempts and inspections support staged evidence.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Upload and verify the referenced offline evidence before synchronizing this command.",
  "Select at most 1000 evidence files.": "Select at most 1000 evidence files.",
  "Finish preparation or closing before synchronizing.": "Finish preparation or closing before synchronizing.",
  "Finish preparation before synchronizing.": "Finish preparation before synchronizing.",
  "The offline command response did not confirm acceptance.": "The offline command response did not confirm acceptance.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Upload and attach the staged offline evidence before closing. Local evidence is retained.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Resolve all pending, conflicting and rejected work before closing this offline session.",
  "The server session was closed elsewhere. Review the retained local work.": "The server session was closed elsewhere. Review the retained local work.",
  "The server did not confirm closing this offline session.": "The server did not confirm closing this offline session.",
  "This file has not been downloaded and verified for offline use.": "This file has not been downloaded and verified for offline use.",
  "This offline session is not ready for new evidence.": "This offline session is not ready for new evidence.",
  "Choose a nonempty evidence file and filename.": "Choose a nonempty evidence file and filename.",
  "This evidence has not been staged for offline use.": "This evidence has not been staged for offline use.",
  "Finish closing before updating evidence.": "Finish closing before updating evidence.",
  "Offline evidence changed. Read its current state before continuing.": "Offline evidence changed. Read its current state before continuing.",
  "Resume the original evidence upload.": "Resume the original evidence upload.",
  "The verified server file does not match the staged evidence.": "The verified server file does not match the staged evidence.",
  "This offline session belongs to another recorder.": "This offline session belongs to another recorder.",
  "This offline session is closed. Its pending work cannot be submitted here.": "This offline session is closed. Its pending work cannot be submitted here.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "This command identity is already bound to different work. Keep the original command and record any correction separately.",
  "Use a serial reserved for this job before the session was prepared.": "Use a serial reserved for this job before the session was prepared.",
  "This component unit changed. Keep the recorded work and review the conflict.": "This component unit changed. Keep the recorded work and review the conflict.",
  "This component revision changed. Keep the recorded work and review the conflict.": "This component revision changed. Keep the recorded work and review the conflict.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.",
  "This material revision changed. Keep the recorded work and review the conflict.": "This material revision changed. Keep the recorded work and review the conflict.",
  "The command payload does not match its record type. Keep the original pending work for review.": "The command payload does not match its record type. Keep the original pending work for review.",
  "Not started": "Not started",
  "In progress": "In progress",
  "Captured part revision was a draft.": "Captured part revision was a draft.",
  "Captured configuration was a draft.": "Captured configuration was a draft.",
  "A captured component revision was a draft.": "A captured component revision was a draft.",
  "Captured material revision was a draft.": "Captured material revision was a draft.",
  "Captured route revision was a draft.": "Captured route revision was a draft.",
  "A captured document revision was a draft.": "A captured document revision was a draft.",
  "No route was captured.": "No route was captured.",
  "An operation has no completed attempt.": "An operation has no completed attempt.",
  "An expected inspection was not recorded.": "An expected inspection was not recorded.",
  "The history includes failed operations.": "The history includes failed operations.",
  "The history includes skipped operations.": "The history includes skipped operations.",
  "The history includes failed inspections.": "The history includes failed inspections.",
  "The history includes inconclusive inspections.": "The history includes inconclusive inspections.",
  "No inspection evidence was recorded.": "No inspection evidence was recorded.",
  "Planned components have no recorded actuals.": "Planned components have no recorded actuals.",
  "A planned component quantity differs from the recorded actuals.": "A planned component quantity differs from the recorded actuals.",
  "Quality has not been declared.": "Quality has not been declared.",
  "Production has not been declared.": "Production has not been declared.",
  "Some actual components are recorded for the whole job, not an individual output.": "Some actual components are recorded for the whole job, not an individual output.",
  "Some completed operations have no file evidence.": "Some completed operations have no file evidence.",
  "An operation was recorded out of order.": "An operation was recorded out of order.",
  "The serial label is void.": "The serial label is void.",
  "Additional evidence warning recorded.": "Additional evidence warning recorded.",
  "Document": "Document",
  "Applies to output": "Applies to output",
  "Earlier lot": "Earlier lot",
  "From lot": "From lot",
  "Captured component evidence": "Captured component evidence",
  "Actual genealogy": "Actual genealogy",
  "Related operation": "Related operation",
  "Shared runs": "Shared runs",
  "Add job to shared run": "Add job to shared run",
  "Actual component type": "Actual component type",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "An accepted recording command must confirm this evidence attachment.",
  "Choose a downloaded material lot or component serial.": "Choose a downloaded material lot or component serial.",
  "Choose a supported evidence update.": "Choose a supported evidence update.",
  "Choose a supported offline command and an object payload.": "Choose a supported offline command and an object payload.",
  "Choose the output receiving this component.": "Choose the output receiving this component.",
  "Evidence file references must be a list of server file IDs.": "Evidence file references must be a list of server file IDs.",
  "Evidence upload failed.": "Evidence upload failed.",
  "Offline payloads must contain only JSON values.": "Offline payloads must contain only JSON values.",
  "Online registry": "Online registry",
  "Provide a corrected command payload object.": "Provide a corrected command payload object.",
  "Provide the evidence upload error.": "Provide the evidence upload error.",
  "Reconnect to verify recorder access before synchronizing.": "Reconnect to verify recorder access before synchronizing.",
  "The offline bundle is missing selected material lots or component units.": "The offline bundle is missing selected material lots or component units.",
  "The offline file SHA-256 does not match its manifest.": "The offline file SHA-256 does not match its manifest.",
  "The offline file URL does not match its session.": "The offline file URL does not match its session.",
  "The offline file length does not match its manifest.": "The offline file length does not match its manifest.",
  "The offline file manifest is invalid.": "The offline file manifest is invalid.",
  "The offline manifest does not match the selected files.": "The offline manifest does not match the selected files.",
  "The offline session does not belong to this recorder and job.": "The offline session does not belong to this recorder and job.",
  "The prepared offline bundle does not match this recorder and job.": "The prepared offline bundle does not match this recorder and job.",
  "The retained correction chain is incomplete.": "The retained correction chain is incomplete.",
  "The retained correction chain is invalid.": "The retained correction chain is invalid.",
  "The selected job changed. Open its download choices again.": "The selected job changed. Open its download choices again.",
  "The selected offline file could not be downloaded.": "The selected offline file could not be downloaded.",
  "The staged evidence failed SHA-256 verification.": "The staged evidence failed SHA-256 verification.",
  "The stored offline evidence failed SHA-256 verification.": "The stored offline evidence failed SHA-256 verification.",
  "The stored offline file failed SHA-256 verification.": "The stored offline file failed SHA-256 verification.",
  "This offline session is closed.": "This offline session is closed.",
  "This offline session is closed. Pending work is retained.": "This offline session is closed. Pending work is retained.",
  "Agent": "Agent",
  "Agents": "Agents",
  "Member": "Member",
  "Agent name": "Agent name",
  "Agent reference": "Agent reference",
  "Connected applications": "Connected applications",
  "Connection address": "Connection address",
  "MCP endpoint": "MCP endpoint",
  "New agent": "New agent",
  "Create agent": "Create agent",
  "Manage": "Manage",
  "Review transfer": "Review transfer",
  "Management transfer awaiting your response": "Management transfer awaiting your response",
  "Management transfer pending": "Management transfer pending",
  "No connected applications.": "No connected applications.",
  "No agents yet.": "No agents yet.",
  "Last used {date}": "Last used {date}",
  "Disconnect": "Disconnect",
  "Disconnect {name}?": "Disconnect {name}?",
  "This application will lose access through this connection.": "This application will lose access through this connection.",
  "Manage {name}?": "Manage {name}?",
  "Accept management": "Accept management",
  "Decline transfer": "Decline transfer",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Accepting management revokes the existing credentials. Create new credentials before running this agent again.",
  "Disabled": "Disabled",
  "Enable agent": "Enable agent",
  "Disable agent": "Disable agent",
  "Enable {name}?": "Enable {name}?",
  "Disable {name}?": "Disable {name}?",
  "Rename": "Rename",
  "Rename agent": "Rename agent",
  "Transfer management": "Transfer management",
  "Cancel transfer": "Cancel transfer",
  "Request transfer": "Request transfer",
  "New manager’s Google account email": "New manager’s Google account email",
  "Share agent reference": "Share agent reference",
  "Company access": "Company access",
  "No company access. A company owner can add this agent in Members.": "No company access. A company owner can add this agent in Members.",
  "Credentials": "Credentials",
  "New credential": "New credential",
  "Create credential": "Create credential",
  "Credential name": "Credential name",
  "No credentials yet.": "No credentials yet.",
  "Rotate secret": "Rotate secret",
  "Rotate {name}?": "Rotate {name}?",
  "Revoke {name}?": "Revoke {name}?",
  "Create new credentials after enabling this agent.": "Create new credentials after enabling this agent.",
  "This revokes its credentials and stops access in every company.": "This revokes its credentials and stops access in every company.",
  "Existing access tokens issued with this credential will stop working.": "Existing access tokens issued with this credential will stop working.",
  "Connection credentials": "Connection credentials",
  "Client ID": "Client ID",
  "Client secret": "Client secret",
  "The secret is shown only once. Save it in your agent’s credential storage.": "The secret is shown only once. Save it in your agent’s credential storage.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.",
  "Copy {value}": "Copy {value}",
  "Copy was unavailable. Select the value and copy it manually.": "Copy was unavailable. Select the value and copy it manually.",
  "Add agent": "Add agent",
  "Choose a valid agent reference.": "Choose a valid agent reference.",
  "Managed by {name}": "Managed by {name}",
  "Connect application": "Connect application",
  "Allow connection": "Allow connection",
  "Redirect address": "Redirect address",
  "This application can use your current company roles. Access follows changes to your memberships.": "This application can use your current company roles. Access follows changes to your memberships.",
  "Agent created": "Agent created",
  "Agent updated": "Agent updated",
  "Agent disabled": "Agent disabled",
  "Credential created": "Credential created",
  "Credential rotated": "Credential rotated",
  "Credential revoked": "Credential revoked",
  "Transfer requested": "Transfer requested",
  "Transfer cancelled": "Transfer cancelled",
  "Transfer accepted": "Transfer accepted",
  "Active agent not found.": "Active agent not found.",
  "Agent not found.": "Agent not found.",
  "Managed agent not found.": "Managed agent not found.",
  "Credential not found.": "Credential not found.",
  "Connection not found.": "Connection not found.",
  "Transfer not found.": "Transfer not found.",
  "This transfer has expired.": "This transfer has expired.",
  "Choose another manager.": "Choose another manager.",
  "The new manager must sign in to the registry first.": "The new manager must sign in to the registry first.",
  "A human account manages agent credentials.": "A human account manages agent credentials.",
  "Enable the agent before creating credentials.": "Enable the agent before creating credentials.",
  "Create a new credential after revocation.": "Create a new credential after revocation.",
  "This agent is already a member.": "This agent is already a member.",
  "Another owner must accept membership before disabling the last owner.": "Another owner must accept membership before disabling the last owner.",
  "Application not found.": "Application not found.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Common parts",
  "Common": "Common",
  "Add part to {value0}": "Add part to {value0}",
  "Assembly actions": "Assembly actions",
  "Create symmetry": "Create symmetry",
  "Variant created.": "Variant created.",
  "Symmetry family updated.": "Symmetry family updated.",
  "Document categories": "Document categories",
  "Document category": "Document category",
  "Add category": "Add category",
  "Edit category": "Edit category",
  "Edit category {name}": "Edit category {name}",
  "Category added.": "Category added.",
  "Category saved.": "Category saved.",
  "Category name": "Category name",
  "Category code": "Category code",
  "App default": "App default",
  "Archived": "Archived",
  "Show archived categories": "Show archived categories",
  "No categories available.": "No categories available.",
  "Reload": "Reload",
  "Only company owners and editors can manage document categories.": "Only company owners and editors can manage document categories.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Existing categories share these codes: {codes}. Their records remain separate.",
  "Upload document": "Upload document",
  "Apply to selected": "Apply to selected",
  "Back to files": "Back to files",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "Browser storage is unavailable. Keep this window open to retain your edits.",
  "Category for {name}": "Category for {name}",
  "Check the saved upload change before continuing.": "Check the saved upload change before continuing.",
  "Choose a matching document": "Choose a matching document",
  "Choose which document should receive this revision.": "Choose which document should receive this revision.",
  "Create a separate document": "Create a separate document",
  "Detected from": "Detected from",
  "Drag and drop files here": "Drag and drop files here",
  "Edit selected files": "Edit selected files",
  "Edit {count} selected files": "Edit {count} selected files",
  "File details and applicability": "File details and applicability",
  "File preview": "File preview",
  "File size": "File size",
  "Filename": "Filename",
  "Keep current": "Keep current",
  "Matching document for {name}": "Matching document for {name}",
  "New document": "New document",
  "New revision of {identifier}": "New revision of {identifier}",
  "Next file": "Next file",
  "Not specified": "Not specified",
  "Preview unavailable for this file format.": "Preview unavailable for this file format.",
  "Preview {name}": "Preview {name}",
  "Previous file": "Previous file",
  "Reading file details…": "Reading file details…",
  "Recover saved upload": "Recover saved upload",
  "Select a file to preview.": "Select a file to preview.",
  "Select all files": "Select all files",
  "Select files": "Select files",
  "Select files to upload.": "Select files to upload.",
  "Select the original file to preview or resume.": "Select the original file to preview or resume.",
  "Select the original file to resume.": "Select the original file to resume.",
  "Select {name}": "Select {name}",
  "Title for {name}": "Title for {name}",
  "Title pattern": "Title pattern",
  "Uploading {name}": "Uploading {name}",
  "Use {name} for the current title and {n} for a sequence number.": "Use {name} for the current title and {n} for a sequence number.",
  "{count} files": "{count} files",
  "{count} selected": "{count} selected",
  "{done} of {total} uploaded": "{done} of {total} uploaded",
  "Add files": "Add files",
  "Retry unfinished uploads": "Retry unfinished uploads",
  "Drawing": "Drawing",
  "Assembly drawing": "Assembly drawing",
  "Production drawing": "Production drawing",
  "Bill of materials": "Bill of materials",
  "Work instruction": "Work instruction",
  "Schematic": "Schematic",
  "Wiring diagram": "Wiring diagram",
  "Layout": "Layout",
  "3D model": "3D model",
  "Test procedure": "Test procedure",
  "Test report": "Test report",
  "Inspection plan": "Inspection plan",
  "Inspection report": "Inspection report",
  "Certificate": "Certificate",
  "Material datasheet": "Material datasheet",
  "Calculation": "Calculation",
  "Requirements": "Requirements",
  "Design report": "Design report",
  "Assembly instruction": "Assembly instruction",
  "Manufacturing process": "Manufacturing process",
  "Quality plan": "Quality plan",
  "Change notice": "Change notice",
  "Manual": "Manual",
  "Upload": "Upload",
  "Ready": "Ready",
  "Needs attention": "Needs attention",
  "Retained": "Retained",
  "manual": "Manual edits",
  "filename": "Filename",
  "embedded metadata": "Embedded metadata",
  "filename fallback": "Filename; general category",
  "Embedded metadata": "Embedded metadata",
  "Embedded title": "Embedded title",
  "File selection key": "File selection key",
  "Media type": "Media type",
  "Document category added": "Document category added",
  "Document category archived": "Document category archived",
  "Document category updated": "Document category updated",
  "Document upload batch created": "Document upload batch created",
  "Document draft retained": "Document draft retained",
  "Document upload saved": "Document upload saved",
  "Add a Company or Project category.": "Add a Company or Project category.",
  "Choose a category available in this document context.": "Choose a category available in this document context.",
  "Choose a project only for a Project category.": "Choose a project only for a Project category.",
  "Choose the project that owns this document context.": "Choose the project that owns this document context.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "This category code already exists in this scope or an inherited scope. Choose another code.",
  "This category is archived. Choose an available category.": "This category is archived. Choose an available category.",
  "This editable category was not found in this company.": "This editable category was not found in this company.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Use an uppercase alphanumeric category code starting with a letter.",
  "A saved document file cannot be removed from its upload batch.": "A saved document file cannot be removed from its upload batch.",
  "A selected file key is already in this batch.": "A selected file key is already in this batch.",
  "Choose a document category.": "Choose a document category.",
  "Choose a row in this upload batch.": "Choose a row in this upload batch.",
  "Choose an available document category.": "Choose an available document category.",
  "Choose between 1 and 1000 files.": "Choose between 1 and 1000 files.",
  "Choose distinct upload rows to edit.": "Choose distinct upload rows to edit.",
  "Choose either an existing document or a new document.": "Choose either an existing document or a new document.",
  "Resume this batch with the recorder who started it.": "Resume this batch with the recorder who started it.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Several documents match this file. Choose the intended document or create a separate document.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "The selected document no longer matches this owner, category and title. Review the row again.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "This document has an unfinished upload. Finish or cancel it before retrying this row.",
  "This upload batch was cancelled.": "This upload batch was cancelled.",
  "This upload row is already saved or cancelled.": "This upload row is already saved or cancelled.",
  "Upload and verify this file before saving the document.": "Upload and verify this file before saving the document.",
  "Select the original file for this upload row.": "Select the original file for this upload row.",
  "This row already has a different upload. Cancel that upload before replacing it.": "This row already has a different upload. Cancel that upload before replacing it.",
  "Preview will be available after upload.": "Preview will be available after upload.",
  "existing document": "Existing document",
  "file extension": "File extension",
  "More": "More",
  "Edit quantity for {value0}": "Edit quantity for {value0}",
  "This structure cannot contain itself.": "This structure cannot contain itself."
}
